

export const SystemEvents: React.FC = () => {
  return (
    <section className="glass-panel p-5 md:p-6 flex flex-col gap-4">
      <h3 className="text-sm md:text-base font-bold text-text-primary">System Events</h3>
      <div className="flex flex-col gap-3 max-h-44 overflow-y-auto pr-1">
        <div className="text-[11px] md:text-xs border-l-2 border-primary-accent pl-2.5 flex flex-col gap-0.5">
          <span className="text-text-primary font-semibold">Expense MFE dynamic entry resolved</span>
          <span className="text-text-muted text-[10px]">08:32 • Override active</span>
        </div>
        <div className="text-[11px] md:text-xs border-l-2 border-accent-violet pl-2.5 flex flex-col gap-0.5">
          <span className="text-text-primary font-semibold">GraphQL persistence Safelist verified</span>
          <span className="text-text-muted text-[10px]">08:15 • SHA-256 Checksum OK</span>
        </div>
        <div className="text-[11px] md:text-xs border-l-2 border-green-500 pl-2.5 flex flex-col gap-0.5">
          <span className="text-text-primary font-semibold">Redux core slices initialized</span>
          <span className="text-text-muted text-[10px]">07:45 • System startup</span>
        </div>
      </div>
    </section>
  );
};
